import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faWallet } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'

const WithdrawFromWallets = () => {
    return (
        <BaseModal modalId="modalWithdrawFromWallets" modalTitle="Withdraw" modalTitleIcon={faWallet} children={<Child />} />
    )
}

export default WithdrawFromWallets


const Child = () => {
    return(
        <form action="#" method="post" className="text-dark">
            <input type="text" className="form-control" placeholder="Unique Wallet Name" />
            <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">Complete <FontAwesomeIcon icon={faCheckCircle} /></button>
        </form>
    )
}